import { FloraButton, styled } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const CartStyles = {
  CloseButton: styled(FloraButton, {
    '&[data-close-cart]': {
      padding: `${theme.sizes['4']} !important`,
      width: '58px',
      height: '58px',
      backgroundColor: 'transparent !important',
      svg: {
        width: '24px',
        height: '24px',
        path: {
          fill: `${theme.colors.action.navigation.standard.static} !important`,
        },
      },
    },
  }),
};
